export const RolesDictionary: Record<string, string> = {
    CANDIDATE: 'CANDIDATE',
    CLIENT: 'CLIENT',
    CONSULTANT: 'CONSULTANT',
};
